export { default } from './AppIcon';
